import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr/traduction.json";
import en from "./locales/en/traduction.json";

i18n
  .use(LanguageDetector) // 👈 LE POINT CLÉ
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "fr",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"], // 👈 persistance
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
